import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import { connect, useDispatch } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { InputWithIcon, Input, Textarea, RadioGroup, Dropdown, Switch, AutoCompleteSelect } from '../../../../itrust_common/components/form';
import { AutoComplete, SaveButton } from '../../../../itrust_common/components/others';
import { onlyPositiveNumbers, required } from '../../../../itrust_common/components/form/FormValidations';
import PayOverTime from './PayOverTime';
import OnlinePaymentWrapper from '../edit/orderOnlinePayments/OnlinePaymentWrapper';
import DevicePayment from './devicePayment/DevicePayment';
import ItrustPayByLink from '../edit/orderOnlinePayments/itrustPayByLink/ItrustPayByLink';
import { useCurrentTypeHook } from '../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';
import { storeSettingLoad } from '../../../../redux/actions/storeSettings/storeSettingActions';
import _ from 'lodash';
import useStoreAllowedPaymentMethods from '../../../../other/helperHooks/useStoreAllowedPaymentMethods';

let PaymentForm = props => {
  const currency = useCurrentTypeHook();
  const dispatch = useDispatch()

  const { selectedModeOfPayment, handleSubmit, paymentType, orderId, orderBalanceDue, orderAmountPaid, order, organisation, currentUser, connect_account_details, isPayOverTime, scheduledPayOverTimeDetails, payment_methods, storeDeviceId, amount, storeId, phoneNumberForLink, isCardTypeRequired } = props
  const AllowedPaymentMethods = useStoreAllowedPaymentMethods(Number(localStorage.getItem('StoreID')) || order.store_id)
  const REFUND_PAYMENT_MODES = AllowedPaymentMethods.filter(item => !['online', 'device', 'link'].includes(item.value))

  useEffect(() => {
    let storeId = (Number(localStorage.getItem('StoreID')) || order.store_id)
    dispatch(storeSettingLoad({ filter: { store_id: storeId }, page: 1, rpp: 9999999, sort: 'position', direction: 'asc' }))
    return () => {
      if (!Number(localStorage.getItem('StoreID'))) { // All store case
        dispatch(storeSettingLoad({ filter: { store_id: '' }, page: 1, rpp: 9999999, sort: 'position', direction: 'asc' }))
      }
    }
  }, [])

  useEffect(() => {
    if (selectedModeOfPayment && (!amount || amount == 0)) {
      dispatch(change(props.form, 'mode_of_payment', ''))
    }
  }, [amount])

  useEffect(() => {
    if (!selectedModeOfPayment || !AllowedPaymentMethods.length) return
    if (AllowedPaymentMethods.some(method => method.value === selectedModeOfPayment)) return

    dispatch(change(props.form, 'mode_of_payment', 'cash'))
  }, [AllowedPaymentMethods, selectedModeOfPayment])

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className={`${paymentType == 'refund' ? 'col-6' : 'col-8'} px-0`}>
          {paymentType !== 'refund' &&
            selectedModeOfPayment === 'online' && connect_account_details &&
            <Field name="is_payover_time" component={Switch} checkedValue={order.is_payover_time} label="Pay Over Time"
              wrapperClasses={`mt-3 mb-5 col-12`} disabled={order.balance_due < 300 || !payment_methods || (payment_methods && payment_methods.length == 0) || (Array.isArray(scheduledPayOverTimeDetails) && scheduledPayOverTimeDetails.length > 0)} />
          }
          {paymentType == 'refund' ?
            <RadioGroup
              containIcons={true}
              name="mode_of_payment"
              radioLabelClasses="mr-4 mb-4 rounded-pill"
              options={REFUND_PAYMENT_MODES}
              label={'Refund Method'}
              wrapperClasses={`${paymentType !== 'refund' && orderBalanceDue === 0 && 'disabled'} col-12 form-group`}
            /> :
            <div className='col-12 payment-method-btn'>
              <RadioGroup
                containIcons={true}
                name="mode_of_payment"
                radioLabelClasses="mr-4 mb-4 rounded-pill"
                options={AllowedPaymentMethods}
                label='Payment Method'
                disabled={(!amount || amount == 0)}
                wrapperClasses={`${paymentType !== 'refund' && orderBalanceDue === 0 && 'disabled'} form-group`}
                // onChangeHook={e => handleModeOfPaymentChange(e)}
              />
            </div>
          }
        </div>

        {(selectedModeOfPayment === 'online' && isPayOverTime) ?
          <PayOverTime isPayOverTime={isPayOverTime} scheduledPayOverTimeDetails={scheduledPayOverTimeDetails} /> :
          <div className="col-4 pl-0">
            <Field name="amount" label="Amount" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses={`${paymentType !== 'refund' && orderBalanceDue === 0 && 'disabled'} ${paymentType == 'refund' && orderAmountPaid === 0 && 'disabled'} form-group`} validate={[onlyPositiveNumbers]} />
          </div>
        }

        {selectedModeOfPayment === 'check' &&
          <Field name="check_details[check_number]" label="Check#" component={Input} className="form-control" wrapperClasses={`${paymentType !== 'refund' && orderBalanceDue === 0 && 'disabled'} col-5 form-group`} />
        }

        {/* <Field
              key={od_contact_lens_attributes && od_contact_lens_attributes.id}
              ref={`${member}[od_contact_lens_id]`}
              name={`${member}[od_contact_lens_id]`}
              displayName={`${member}[od_contact_lens_attributes][brand_name]`}
              component={AutoCompleteSelect}
              onChangeHook={() => this.onContactLensSelect("od")}
              klass="Settings::ContactLens"
              additionalFilters={{ store_inventory: this.getStoreIdForSearch() }}
              textField="brand_name"
              valueField="id"
              placeholder="Placeholder"
              wrapperClasses="col-4 px-0 form-group"
              className="form-control"
              label={this.renderOdLabel(od_contact_lens_attributes?.manufacturer_name)}
              labelClasses="w-100"
              /> */}

        {selectedModeOfPayment === 'card' &&
          <Field
            name="card_details[card_type]"
            label="Card Type"
            component={AutoCompleteSelect}
            // data={storeAllowedCardTypesData}
            klass="StoreSetting"
            additionalFilters={{ category: 'card_types', is_archived: false, store_id: Number(localStorage.getItem('StoreID')) || order.store_id }}
            valueField="name"
            textField="name"
            wrapperClasses={`${paymentType !== 'refund' && orderBalanceDue === 0 && 'disabled'}  col-5`}
            validate={isCardTypeRequired ? [required] : []}
          />
        }
        {paymentType !== 'refund' && selectedModeOfPayment === 'online' &&
          <>
            <OnlinePaymentWrapper />
            {/* {organisation.connect_account_details.account_payouts_enabled ?
              <div className='col-12'>
                <CardPayment ref={childRef} scheduledPayOverTimeDetails={scheduledPayOverTimeDetails} scheduledPayOverTimePaymentMethodId={scheduledPayOverTimePaymentMethodId} orderId={orderId} order={order} setPaymentMethod={setPaymentMethod} setSetupIntentId={setSetupIntentId} setupIntentId={setupIntentId} />
              </div> :
              <div className="col-8">
                {["super_admin", "itrust_admin"].includes(currentUser.role) ?
                  <>
                    <span className="text-danger">
                      Your online card payments are not live,
                    <Link to="/add-ons/itrust-pay/dashboard" className="text-danger font-weight-bold" onClick={() => { $('#orderForm-modal').modal('hide'); $('.modal-backdrop').remove() }}>
                        <u className="mx-2">activate it now.</u>
                      </Link>
                    </span>
                    <img src={OnlinePaymentDisabledImg} className="w-75 cursor-not-allowed mt-2" />
                  </> :
                  <>
                    <p className="text-danger">
                      Your online card payments are not live, contact your administrator to activate it.
                    </p>
                    <img src={OnlinePaymentDisabledImg} className="w-75 cursor-not-allowed" />
                  </>}
              </div>
            } */}
          </>
        }
        {paymentType !== 'refund' && selectedModeOfPayment === 'device' &&
          <DevicePayment orderId={orderId} orderStaffId={order.staff_attributes.id} storeDeviceId={storeDeviceId} amount={amount} orderBalanceDue={orderBalanceDue} />
        }
        {paymentType !== 'refund' && selectedModeOfPayment === 'link' && <ItrustPayByLink orderId={orderId} storeId={storeId} staffId={currentUser.id} phoneNumberForLink={phoneNumberForLink} amount={amount} orderBalanceDue={orderBalanceDue} />}
        <Field name="notes" label="Comments" component={Textarea} rows={4} className="form-control" wrapperClasses="col-12 form-group mt-5" />
      </div>
      {/* {
        paymentType == 'refund' &&
        <div className="text-right">
          <SaveButton saving={saving} />
        </div>
      } */}
    </form>
  )
}

PaymentForm = reduxForm({
  enableReinitialize: true
})(PaymentForm)


PaymentForm = connect((state, ownProps) => {
  const selector = formValueSelector(ownProps.form)
  const { order, auth: { user }, organisation: { organisation }, patientPaymentMethod: { payment_methods }, orderPayment: { payment }, currentStore, storeSetting } = state
  const selectedModeOfPayment = selector(state, 'mode_of_payment')
  const amount = selector(state, 'amount')
  const phoneNumberForLink = selector(state, 'phone_number')
  const isPayOverTime = selector(state, 'is_payover_time')
  const storeAllowedPaymentMethods = storeSetting?.filtered_store_settings?.payment_method?.[0]?.store_config?.payment_methods || {}

  const isiTrustPayActive = organisation.add_ons_config.type?.itrust_pay?.status !== 'inactive' && organisation.add_ons_config.type.itrust_pay?.visible
  let modeOfPayment = ownProps.paymentType === 'refund'
    ? 'cash'
    : isiTrustPayActive
      ? (organisation.add_ons_config?.type?.itrust_pay?.gateway === 'authorize' ? 'cash' : 'device')
      : (Object.keys(storeAllowedPaymentMethods).find(key => storeAllowedPaymentMethods[key] === true) || 'cash')

  return {
    organisation,
    phoneNumberForLink,
    order: order.order,
    storeId: currentStore.store.id,
    isPayOverTime,
    selectedModeOfPayment: selectedModeOfPayment,
    currentUser: user,
    saving: order.saving,
    orderId: order.order.id,
    amount,
    storeDeviceId: currentStore.store?.itrust_pay_device_config?.payarc_devices,
    orderBalanceDue: order.order.balance_due,
    orderAmountPaid: order.order.amount_paid,
    // scheduledPayOverTimePaymentMethodId: order.order.payover_time_details && order.order.payover_time_details.payment_method_id,
    scheduledPayOverTimeDetails: order.order.payovers_attributes,
    connect_account_details: organisation.connect_account_details,
    payment_methods,
    isCardTypeRequired: storeSetting.filtered_store_settings.payment_method?.[0]?.store_config.is_card_type_required || false,
    initialValues: {
      is_payover_time: order.order.is_payover_time,
      orders_order_id: order.order.id,
      mode_of_payment: modeOfPayment,
      payment_date: Moment(new Date()).format("YYYY/MM/DD"),
      payment_type: ownProps.paymentType,
      staff_id: user.id,
      prior_authorization_number: order.order.prior_authorization_number,
      amount: ownProps.paymentType === 'sale' && isiTrustPayActive ? order.order.balance_due : '',
      payover_time_details: {
        amount: order.order.balance_due,
        months: 3,
        schedule_date: Moment(new Date()).format("MM/DD/YYYY").toString(),
      },
      payment_method_id: payment_methods[0]?.card_id,
      phone_number: order?.order?.patient_attributes?.cell_phone,
      customer_id: payment_methods[0]?.customer_id
    }
  }
})(PaymentForm)

export default PaymentForm
